import Styles from '../AIAssistant.module.scss'
import { ActionCard } from 'components/DocRightRail/screens/AIAssistant/ActionCard'
import { Content } from 'components/DocRightRail/screens/AIAssistant/Card'
import { ArrowRight } from 'blaze-ui/icons'
import { useHover } from '@react-aria/interactions'
import cx from 'classnames'

interface NextStepProps {
  actionText: string
  onPress: () => void
  icon: JSX.Element
  className?: string
}

export const BaseNextStep = ({ actionText, icon, onPress, className }: NextStepProps) => {
  const { hoverProps, isHovered } = useHover({})

  return (
    <ActionCard onClick={onPress} className={cx(Styles.nextActionCard, className)} {...hoverProps}>
      <div className={Styles.contentWrapper}>
        <Content withIcon>
          {icon}
          <div className={Styles.nextAction}>{actionText}</div>
          <div className={cx(Styles.arrowRight, { [Styles.hovered]: isHovered })}>
            <ArrowRight />
          </div>
        </Content>
      </div>
    </ActionCard>
  )
}
